export const environment = {
  name: "test",
  production: false,
  api: {
    host : 'https://backofficeapi-test.backstage.solutions',
    boxoffice : 'https://api-test.backstage.solutions',
    cms : 'https://beeswax-webapi-test.azurewebsites.net',
  	path: 'api/v1.0',
  	cmspath: 'api/beeswax'
  },
  venued: {
    jsPath : "https://backstage-test.mobilet.com/venued/1.1/dist/js/venued.min.js"
  },
  emailValidation: {
    linkUrl: 'https://test.mobilet.com/validate-email'
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts